import { GLOBAL_COMMUNITY_OPTION } from '../../constants';

export const mapIdentificationCodeToForm = values =>
  !values
    ? null
    : {
        ...values,
        identificationCodeTypeTag: values.type?.tag,
        communityTag: values.community?.tag || GLOBAL_COMMUNITY_OPTION.value,
      };
